$(function () {
    $(".StoneBox div").click(function () {
        if ($(this).siblings("input").attr("type") == "radio") {
            clearAllStones();
        }

        var elem = $(this).siblings('input');
        var selectedClass = $(elem).attr('data-selectedClass');

        if (getElement(elem.attr('id')).checked == true)
            $(elem).attr('checked', false);
        else
            $(elem).attr('checked', true);
        SetStonePic(elem.attr('id'), selectedClass);
    });
});

function SetStonePic(id, selectedClass) {
    var checkBox = $('#' + id);
    var imgDiv = checkBox.siblings("div").not(".stoneQTipInfo");

    if (checkBox.attr('checked') == 'checked') {
        $(imgDiv).parent().addClass("selectedStone");
        $(imgDiv).addClass(selectedClass);
    }
    else {
        $(imgDiv).parent().removeClass("selectedStone");
        $(imgDiv).removeClass(selectedClass);
    }
}

function getShapeList() {
    var shapeList = new Array();

    $(".StoneCheck:checked").each(function () {
        shapeList.push($(this).val());
    });

    return shapeList;
}

function getSelectedShape() {
    return $(".StoneBox.selectedStone").children("input").val();
}

function clearAllStones() {
    $(".StoneBox").each(function () {
        $(this).removeClass("selectedStone");
        $(this).children("input").attr("checked", false);
        var selectedClass = $(this).children("input").attr("data-selectedClass");
        $(this).children("div").removeClass(selectedClass);
    });
}

function checkStone(thisStone) {
    thisStone.attr("checked", true);
    thisStone.siblings("div").addClass("selectedStoneImage");
    thisStone.parent("div").addClass("selectedStone");
}

function uncheckStone(thisStone) {
    thisStone.attr("checked", false);
    thisStone.siblings("div").removeClass("selectedStoneImage");
    thisStone.parent("div").removeClass("selectedStone");
}